import { SECOND } from "@brookbush/types";

import { intervalToDuration } from "date-fns";
import type * as React from "react";
import { useEffect, useState } from "react";

import useSale from "~/hooks/useSale";
import { startCountdownInterval } from "~/utils/startCountdownInterval";

type BecomeAMemberSaleCounterProps = {};

const BecomeAMemberSaleCounter: React.FC<
	BecomeAMemberSaleCounterProps
> = ({}) => {
	const { sale } = useSale();

	const [duration, setDuration] = useState(
		sale &&
			intervalToDuration({
				start: new Date(sale?.endsAt),
				end: new Date(),
			}),
	);

	useEffect(() => {
		if (!sale) return;

		return startCountdownInterval(sale.endsAt, setDuration, SECOND);
	}, [sale]);

	if (!sale) return null;

	return (
		<div className="mx-auto my-2 flex gap-2 tablet:gap-10">
			{Object.entries(duration || {})
				.filter(([key]) => !["months", "years"].includes(key))
				.map(([key, value]) => (
					<div
						key={key}
						className="flex w-14 flex-col items-center justify-center rounded-lg bg-orange-100 pt-1 pb-1.5 font-medium text-orange-900 dark:bg-orange-300/20 dark:text-orange-50"
					>
						<span className="font-semibold text-3xl">{value}</span>

						<span className="-mt-0.5 text-sm capitalize">
							{key === "seconds" ? "Secs" : key === "minutes" ? "Mins" : key}
						</span>
					</div>
				))}
		</div>
	);
};

export default BecomeAMemberSaleCounter;
